<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.667 13.334C14.4284 13.334 16.667 11.0954 16.667 8.33398C16.667 5.57256 14.4284 3.33398 11.667 3.33398C8.90557 3.33398 6.66699 5.57256 6.66699 8.33398C6.66699 11.0954 8.90557 13.334 11.667 13.334Z"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.6671 20H9.83043C8.61196 20.0003 7.43556 20.4456 6.52223 21.2521C5.6089 22.0587 5.02152 23.1709 4.87043 24.38L3.80209 32.92C3.74348 33.3891 3.7853 33.8652 3.92477 34.3169C4.06424 34.7685 4.29818 35.1853 4.61105 35.5397C4.92393 35.894 5.30859 36.1777 5.7395 36.372C6.17042 36.5663 6.63773 36.6668 7.11043 36.6667H15.0004"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.1988 32.92L35.1321 24.38C34.981 23.1704 34.3931 22.0576 33.4791 21.251C32.565 20.4444 31.3878 19.9995 30.1688 20H26.4955C25.277 20.0003 24.1006 20.4456 23.1873 21.2521C22.2739 22.0587 21.6866 23.1709 21.5355 24.38L20.4671 32.92C20.4085 33.3892 20.4504 33.8655 20.5899 34.3172C20.7295 34.769 20.9636 35.1859 21.2766 35.5403C21.5897 35.8946 21.9746 36.1783 22.4057 36.3725C22.8368 36.5667 23.3043 36.667 23.7771 36.6667H32.8905C33.3632 36.6668 33.8305 36.5663 34.2614 36.372C34.6923 36.1777 35.077 35.894 35.3898 35.5397C35.7027 35.1853 35.9367 34.7685 36.0761 34.3169C36.2156 33.8652 36.2574 33.389 36.1988 32.92Z"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.333 13.334C31.0944 13.334 33.333 11.0954 33.333 8.33398C33.333 5.57256 31.0944 3.33398 28.333 3.33398C25.5716 3.33398 23.333 5.57256 23.333 8.33398C23.333 11.0954 25.5716 13.334 28.333 13.334Z"
      stroke="#F57E53"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
